import * as type from './LaboratoryType';
const initialState = {
    patientId: null,
    loading: false,
    initialized: false,
    laboratoryTestImagesResults: [],
    laboratoryTestGroups: [],
    factors: []
};

export const laboratoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.SET_LABORATORY_IMAGES_GROUPS:
            return {
                ...state,
                laboratoryTestImagesResults: action.payload
            };

        case type.SET_LABORATORY_TEST_GROUPS:
            return {
                ...state,
                laboratoryTestGroups: action.payload
            };
        case type.DELETE_LABORATORY_TEST: {
            const findTable = state.laboratoryTestGroups.find((item) => item.id === action.tableId);
            const results = findTable.results.filter((item) => item.id !== action.payload);
            if (results.length) {
                return {
                    ...state,
                    laboratoryTestGroups: [{ ...findTable, results: results }]
                };
            } else {
                return {
                    ...state,
                    laboratoryTestGroups: []
                };
            }
        }
        case type.SET_FETCHING_STATE:
            return {
                ...state,
                ...action.payload
            };

        case type.SET_LABORATORY_FACTOR_LIST:
            return {
                ...state,
                factors: action.payload
            };
        default:
            return state;
    }
};
